module.exports = __webpack_public_path__ + "img/logo.5558e9ec.png";